/**
 * Trees Store - State for tree inventory layer
 */

import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

interface SelectedTreeTask {
  projectId: number;
  taskId: string;
  name: string;
}

interface TreesState {
  // Selected WebODM task for trees
  selectedTask: SelectedTreeTask | null;
  
  // Visibility
  showTrees: boolean;
  
  // Harvest filters
  showHarvestableOnly: boolean;
  showProtectedOnly: boolean;
  
  // Quality filters
  highConfidenceOnly: boolean;  // 90%+ confidence
  
  // Timber class filter
  timberClassFilter: string | null;  // A, B, C, D or null for all
  
  // Actions
  setSelectedTask: (task: SelectedTreeTask | null) => void;
  setShowTrees: (show: boolean) => void;
  setShowHarvestableOnly: (show: boolean) => void;
  setShowProtectedOnly: (show: boolean) => void;
  setHighConfidenceOnly: (show: boolean) => void;
  setTimberClassFilter: (timberClass: string | null) => void;
  clearFilters: () => void;
}

export const useTreesStore = create<TreesState>()(
  devtools(
    (set) => ({
      selectedTask: null,
      showTrees: true,
      showHarvestableOnly: false,
      showProtectedOnly: false,
      highConfidenceOnly: false,
      timberClassFilter: null,
      
      setSelectedTask: (task) => set({ selectedTask: task }),
      
      setShowTrees: (show) => set({ showTrees: show }),
      
      setShowHarvestableOnly: (show) => set({ 
        showHarvestableOnly: show,
        showProtectedOnly: show ? false : false,
      }),
      
      setShowProtectedOnly: (show) => set({ 
        showProtectedOnly: show,
        showHarvestableOnly: show ? false : false,
      }),
      
      setHighConfidenceOnly: (show) => set({ highConfidenceOnly: show }),
      
      setTimberClassFilter: (timberClass) => set({ timberClassFilter: timberClass }),
      
      clearFilters: () => set({
        showHarvestableOnly: false,
        showProtectedOnly: false,
        highConfidenceOnly: false,
        timberClassFilter: null,
      }),
    }),
    { name: 'TreesStore' }
  )
);
